// extracted by mini-css-extract-plugin
export default {"container":"CentralGridLayout_container__mC-fa"};